// The anonymous "mine" list per branch (G1/G7): `localStorage`, newest first, capped,
// never pruned otherwise (2026-09-04). Logged-in customers have the account's history (H6).

export const MY_ORDERS_CAP = 20

function key(restaurantSlug: string, branchSlug: string) {
  return `romi.orders.${restaurantSlug}/${branchSlug}`
}

export function myOrderCodes(restaurantSlug: string, branchSlug: string): string[] {
  try {
    const raw = localStorage.getItem(key(restaurantSlug, branchSlug))
    const parsed: unknown = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.filter((c): c is string => typeof c === 'string') : []
  } catch {
    return []
  }
}

export function rememberMyOrder(restaurantSlug: string, branchSlug: string, code: string) {
  const codes = [code, ...myOrderCodes(restaurantSlug, branchSlug).filter((c) => c !== code)].slice(0, MY_ORDERS_CAP)
  try {
    localStorage.setItem(key(restaurantSlug, branchSlug), JSON.stringify(codes))
  } catch {
    // Storage blocked: the tracking page still opens from the redirect; only "mine" is lost.
  }
}
